export default "__VITE_ASSET__CFGMtzKl__"